import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';

import GET_CENTRALIZED_ORGANIZATION from './graphql/GetCentralizedOrganization.v5.graphql';
import type {
  GetCentralizedOrganization,
  GetCentralizedOrganizationVariables,
} from './graphql/types/GetCentralizedOrganization';

const useCentralizedOrganization = () => {
  const router = useRouter();
  const { slug } = router.query as { slug: string };

  const { data, loading } = useQuery<
    GetCentralizedOrganization,
    GetCentralizedOrganizationVariables
  >(GET_CENTRALIZED_ORGANIZATION, {
    fetchPolicy: 'no-cache',
    variables: {
      organizationSlug: slug,
    },
    skip: !slug,
    context: { clientName: 'v5' },
  });

  return {
    originalId: data?.get_organization_by_learning_slug?.original_id,
    slug: data?.get_organization_by_learning_slug?.slug,
    name: data?.get_organization_by_learning_slug?.name,
    template: data?.get_organization_by_learning_slug?.user_create_template,
    isLoading: loading,
  };
};

export default useCentralizedOrganization;
